import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Header } from "../components/Header";
import { HeroSection } from "../components/HeroSection";
import { MarqueeSection } from "../components/MarqueeSection";
import { ServicesSection } from "../components/ServicesSection";
import { AboutSection } from "../components/AboutSection";
import { SlotMachineSection } from "../components/SlotMachineSection";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { Journey } from "../components/Journey";
import { useLanguage } from "../context/LanguageContext";
import { ScrollTrigger, scrollToId } from "../lib/gsap";

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const [contactTab, setContactTab] = useState("contact");
  const { language } = useLanguage();

  useEffect(() => {
    const id = setTimeout(() => ScrollTrigger.refresh(), 200);
    return () => clearTimeout(id);
  }, [language]);

  useEffect(() => {
    if (searchParams.get('demo') === 'true') {
      setContactTab("demo");
      setTimeout(() => scrollToId("contact"), 300);
    }
  }, [searchParams]);

  const handleDemoClick = () => {
    setContactTab("demo");
    scrollToId("contact");
  };

  return (
    <div data-testid="home-page">
      <Header onDemoClick={handleDemoClick} />
      <main>
        <Journey>
          <HeroSection onDemoClick={handleDemoClick} />
          <SlotMachineSection />
          <ServicesSection />
          <MarqueeSection />
          <AboutSection />
          <div data-scene="5" data-scene-at="start" aria-hidden="true" />
          <ContactSection activeTab={contactTab} setActiveTab={setContactTab} />
        </Journey>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
